import { render, staticRenderFns } from "./addNewCar.vue?vue&type=template&id=0641c9d7&"
import script from "./addNewCar.vue?vue&type=script&lang=js&"
export * from "./addNewCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports